define("shared/components/shared/upgrade/mobile-upgrade-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showModal}}
    <Shared::Modal
      @close={{this.closeModal}}
      @focusTrap={{true}}
      class="is--top"
      data-test-id="mobile-upgrade-modal"
      as |modal|
    >
      <modal.card @portrait={{false}} class={{this.config.imageCSSClass}}>
        <modal.card-body>
          <div class="u--row u--row--noCollapse" data-test-id="mobile-upgrade-modal-body">
            <div class="u--col__6 u--col__push--6">
              <modal.card-header class="u--p__b__xs">
                <p class="o--modalHeader__title u--text--lg u--m__b__sm">{{this.config.modalTitle}}</p>
                <p class="u--m__0 u--text--md">{{this.config.modalSubtitle}}</p>
              </modal.card-header>
              <modal.card-body class="u--p__t__0">
                <p class="u--text--md u--m__b__lg"></p>
                <ol class="u--listUnstyle u--m__b__lg u--m__r__md">
                  <li class="u--m__b__lg">
                    <p class="u--text--light u--text--bold u--m__b__xs">{{t "plans.mobile.redirect.step_1"}}</p>
                    <p class="u--text--md">{{this.config.stepOneDescription}}</p>
                  </li>
                  <li class="u--m__b__lg">
                    <p class="u--text--light u--text--bold u--m__b__xs">{{t "plans.mobile.redirect.step_2"}}</p>
                    <p class="u--text--md">
                      {{html-safe this.config.stepTwoDescription}}
                    </p>
                  </li>
                  <li class="u--m__b__lg">
                    <p class="u--text--light u--text--bold u--m__b__xs">{{t "plans.mobile.redirect.step_3"}}</p>
                    <p class="u--text--md">{{html-safe this.config.stepThreeDescription}}</p>
                  </li>
                </ol>
                <div class="cIC--card">
                  <div class="cIC--cardBody u--p__r__sm u--p__t__sm">
                    <p class="u--m__0">{{svg-jar "info" class="o--icon--sm u--m__r__xs"}}{{this.delayTooltip}}</p>
                  </div>
                </div>
              </modal.card-body>
            </div>
          </div>
        </modal.card-body>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "RYq34SXx",
    "block": "[[[41,[30,0,[\"showModal\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"is--top\"],[24,\"data-test-id\",\"mobile-upgrade-modal\"]],[[\"@close\",\"@focusTrap\"],[[30,0,[\"closeModal\"]],true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],[[16,0,[30,0,[\"config\",\"imageCSSClass\"]]]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[14,\"data-test-id\",\"mobile-upgrade-modal-body\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__6 u--col__push--6\"],[12],[1,\"\\n            \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__xs\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,2],[14,0,\"o--modalHeader__title u--text--lg u--m__b__sm\"],[12],[1,[30,0,[\"config\",\"modalTitle\"]]],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--m__0 u--text--md\"],[12],[1,[30,0,[\"config\",\"modalSubtitle\"]]],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[13],[1,\"\\n              \"],[10,\"ol\"],[14,0,\"u--listUnstyle u--m__b__lg u--m__r__md\"],[12],[1,\"\\n                \"],[10,\"li\"],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n                  \"],[10,2],[14,0,\"u--text--light u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"plans.mobile.redirect.step_1\"],null]],[13],[1,\"\\n                  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[30,0,[\"config\",\"stepOneDescription\"]]],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"li\"],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n                  \"],[10,2],[14,0,\"u--text--light u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"plans.mobile.redirect.step_2\"],null]],[13],[1,\"\\n                  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n                    \"],[1,[28,[35,3],[[30,0,[\"config\",\"stepTwoDescription\"]]],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,\"li\"],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n                  \"],[10,2],[14,0,\"u--text--light u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"plans.mobile.redirect.step_3\"],null]],[13],[1,\"\\n                  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,3],[[30,0,[\"config\",\"stepThreeDescription\"]]],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"cIC--card\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"cIC--cardBody u--p__r__sm u--p__t__sm\"],[12],[1,\"\\n                  \"],[10,2],[14,0,\"u--m__0\"],[12],[1,[28,[35,4],[\"info\"],[[\"class\"],[\"o--icon--sm u--m__r__xs\"]]]],[1,[30,0,[\"delayTooltip\"]]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],null]],[\"modal\"],false,[\"if\",\"shared/modal\",\"t\",\"html-safe\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/upgrade/mobile-upgrade-modal.hbs",
    "isStrictMode": false
  });
  // Note: should be moved to subscription service when it is ts
  let MobileUpgradeModalComponent = _exports.default = (_class = class MobileUpgradeModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "events", _descriptor3, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _defineProperty(this, "originalPlanName", void 0);
      this.originalPlanName = this.subscriptions.planName;
      this.events.on('account:updated', this.onPlanChanged);
    }
    willDestroy() {
      super.willDestroy();
      this.events.off('account:updated', this.onPlanChanged);
    }
    get featureName() {
      return this.subscriptions.currentMobileModalFeatureName;
    }
    get config() {
      const featureKey = this.featureName;
      if (this.FEATURE_MAP[featureKey]) {
        return {
          ...this.defaultConfig,
          ...this.FEATURE_MAP[featureKey]
        };
      }
      return this.defaultConfig;
    }

    /**
     * Store custom overrides for modal properties based on feature area
     * Keys map to featureMapList keys in featureMapList in lib/plans/addon/routes/upgrade.js
     * A shared type should be created when that is converted to TS to enforce this relationship
     */
    get FEATURE_MAP() {
      return Object.freeze({
        shareCalendar: {
          modalTitle: this.growthModalTitle,
          modalSubtitle: this.growthModalSubtitle,
          imageCSSClass: 'tOB--image__redirectMobileShareCalendar',
          stepOneDescription: this.intl.t('plans.mobile.redirect.step_1_desc_share_calendar', {
            platform: this.subscriptionPlatform
          }),
          stepTwoDescription: this.intl.t('plans.mobile.redirect.step_2_desc'),
          stepThreeDescription: this.intl.t('plans.mobile.redirect.step_3_desc_share_calendar')
        }
      });
    }
    get defaultConfig() {
      return {
        imageCSSClass: 'tOB--image__redirectMobile',
        modalTitle: this.modalTitle,
        modalSubtitle: this.modalSubtitle,
        stepOneDescription: this.stepOneDescription,
        stepTwoDescription: this.stepTwoDescription,
        stepThreeDescription: this.stepThreeDescription
      };
    }
    get isPaidPlan() {
      return Boolean(this.auth.currentAccount?.hasActiveSubscription);
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get canTrialPlan() {
      return Boolean(this.auth.currentAccount?.canTrialPlan);
    }
    get delayTooltip() {
      if (this.canTrialPlan) {
        return this.intl.t('plans.mobile.redirect.update_tooltip_trial', {
          platform: this.subscriptionPlatform
        });
      }
      if (this.subscriptions.isPaid) {
        return this.intl.t('plans.mobile.redirect.update_tooltip', {
          platform: this.subscriptionPlatform
        });
      }
      return this.intl.t('plans.mobile.redirect.update_tooltip_free', {
        platform: this.subscriptionPlatform
      });
    }
    get subscriptionPlatform() {
      return this.subscriptions.platform;
    }
    get growthModalTitle() {
      return this.canTrialPlan ? this.intl.t('plans.mobile.redirect.manage_plan_growth_trial', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.redirect.manage_plan_growth', {
        platform: this.subscriptionPlatform
      });
    }
    get growthModalSubtitle() {
      return this.canTrialPlan ? this.intl.t('plans.mobile.redirect.manage_plan_desc_growth_trial', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.redirect.manage_plan_desc_growth', {
        platform: this.subscriptionPlatform
      });
    }
    get modalTitle() {
      if (this.isPaidPlan) {
        return this.intl.t('plans.mobile.redirect.manage_plan', {
          platform: this.subscriptionPlatform
        });
      }
      return this.canTrialPlan ? this.intl.t('plans.mobile.redirect.start_trial', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.redirect.upgrade_plan', {
        platform: this.subscriptionPlatform
      });
    }
    get modalSubtitle() {
      if (this.isPaidPlan) {
        return this.intl.t('plans.mobile.redirect.manage_plan_desc', {
          platform: this.subscriptionPlatform
        });
      }
      return this.canTrialPlan ? this.intl.t('plans.mobile.redirect.start_trial_desc', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.redirect.upgrade_plan_desc', {
        platform: this.subscriptionPlatform
      });
    }
    get stepOneDescription() {
      return this.intl.t('plans.mobile.redirect.step_1_desc', {
        platform: this.subscriptionPlatform
      });
    }
    get stepTwoDescription() {
      if (this.isPaidPlan) {
        return this.intl.t('plans.mobile.redirect.step_2_paid_desc');
      }
      return this.intl.t('plans.mobile.redirect.step_2_desc');
    }
    get stepThreeDescription() {
      if (this.isPaidPlan) {
        return this.intl.t('plans.mobile.redirect.step_3_desc_manage_plan', {
          platform: this.subscriptionPlatform
        });
      }
      return this.canTrialPlan ? this.intl.t('plans.mobile.redirect.step_3_desc_start_trial', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.redirect.step_3_desc_upgrade_plan', {
        platform: this.subscriptionPlatform
      });
    }
    get showModal() {
      return this.subscriptions.showMobileRedirectModal;
    }
    onPlanChanged() {
      if (!this.showModal) {
        return;
      }

      // Note: if addons are added to an existing plan, the planName will not change.
      if (this.originalPlanName === this.subscriptions.planName) {
        return;
      }
      this.alerts.success(this.intl.t('plans.mobile.plan_changed_alert.upgrade_desc', {
        planName: this.subscriptions.planName
      }), {
        title: this.intl.t('plans.mobile.plan_changed_alert.upgrade_title'),
        sticky: true
      });
      this.subscriptions.closeMobileRedirectModal();
    }
    closeModal() {
      this.subscriptions.closeMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "events", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onPlanChanged", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onPlanChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobileUpgradeModalComponent);
});